import React, { createContext, useContext, useState } from "react";

const PanelContext = createContext();

export const usePanels = () => {
  const context = useContext(PanelContext);
  if (!context) {
    throw new Error("usePanels must be used within a PanelProvider");
  }
  return context;
};

export const PanelProvider = ({ children }) => {
  // Generic right-side panel counter to shrink layout when any is open
  const [rightPanelCount, setRightPanelCount] = useState(0);
  // Track individual right panel widths by id (in px)
  const [rightPanels, setRightPanels] = useState({});
  /** Synced from ProtectedLayout: main has extra right margin (AI, notifications, SidePanels, etc.) */
  const [mainContentRightInsetActive, setMainContentRightInsetActive] = useState(false);

  const incrementRightPanel = () => setRightPanelCount((c) => c + 1);
  const decrementRightPanel = () => setRightPanelCount((c) => (c > 0 ? c - 1 : 0));

  const registerRightPanel = (id, widthPx) => {
    setRightPanels((prev) => ({ ...prev, [id]: widthPx || 0 }));
  };

  const unregisterRightPanel = (id) => {
    setRightPanels((prev) => {
      const copy = { ...prev };
      delete copy[id];
      return copy;
    });
  };

  const maxRightPanelWidth = Object.values(rightPanels).reduce((max, w) => (w > max ? w : max), 0);

  const value = {
    rightPanelCount,
    maxRightPanelWidth,
    mainContentRightInsetActive,
    setMainContentRightInsetActive,
    incrementRightPanel,
    decrementRightPanel,
    registerRightPanel,
    unregisterRightPanel,
  };

  return <PanelContext.Provider value={value}>{children}</PanelContext.Provider>;
};
